module.exports = __webpack_public_path__ + "static/media/access-bank-wallet.9a0d32f5.svg";